// this file was auto-generated by yo breck:model

export enum DonorStatuses {
    PostRegistration = 1,
    BasicInformation = 2,
    PreliminaryHistory = 3,
    MedicalIssues = 4,
    PendingMedicalReview = 5,
    TestSampleSchedulePending = 6,
    TestSampleScheduled = 7,
    PersonalHistory = 8,
    InterviewSchedulePending = 9,
    InterviewScheduled = 10,
    InterviewComplete = 11,
    PsychCarrierScreeningPending = 12,
    ReadyForApproval = 13,
    Approved = 14,
    Denied = 15,
    PsychCarrierScreeningScheduled = 17,
    PsychCarrierScreeningResultsPending = 18,
    GeneticCounselingPending = 19,
    GeneticCounselingScheduled = 20,
    GeneticCounselingResultsPending = 21,
    AdditionalBloodTestingPending = 22,
    AdditionalBloodTestingScheduled = 23,
    AdditionalBloodTestingResultsPending = 24,
}
